function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import { Animated, Pressable } from 'react-native';
import Colors from '../colors';
const AnimatedPressable = Animated.createAnimatedComponent(Pressable);
const StyledPressable = styled.Pressable`
  background-color: ${props => props.active ? props.color : Colors.lightGray400};
  opacity: ${props => props.disabled ? 0.4 : 1};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  width: 48px;
  border-radius: 40px;
`;
const StyledToggle = styled(AnimatedPressable)`
  background-color: ${Colors.white};
  border-radius: 50px;
  height: 20px;
  width: 20px;
  margin: 3px;
`;

const startPosition = toggle => {
  const start = toggle ? 22 : 0;
  return new Animated.Value(start);
};

const alignmentStyle = alignment => ({
  transform: [{
    translateX: alignment
  }]
});

const animateToggle = (alignment, toggle) => {
  const endPosition = toggle ? 0 : 22;
  Animated.timing(alignment, {
    toValue: endPosition,
    duration: 200,
    useNativeDriver: true
  }).start();
};

export default function Toggle(props) {
  const [toggle, setToggle] = useState(props.active);
  const ref = useRef(startPosition(toggle)).current;
  const toggleProps = {
    active: toggle,
    disabled: props.disabled,
    onPress: () => onChange(props.onToggle)
  };

  const onChange = callback => {
    setToggle(!toggle);
    animateToggle(ref, toggle);
    callback();
  };

  return /*#__PURE__*/React.createElement(StyledPressable, _extends({
    color: props.color
  }, toggleProps), /*#__PURE__*/React.createElement(StyledToggle, _extends({
    style: alignmentStyle(ref)
  }, toggleProps)));
}
Toggle.defaultProps = {
  color: Colors.mint400,
  active: false,
  disabled: false,
  onToggle: () => {}
};
Toggle.propTypes = {
  color: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func
};
//# sourceMappingURL=index.js.map